import React from 'react';

import PaperContainer from '../../common-components/PaperContainer';
import Page from '../../common-components/Page';
import Grid from '@material-ui/core/Grid';

import DMYGraphFilterForm from './DMYGraphFilterForm';
import DMYGraphFilterFieldForm from './DMYGraphFilterFieldForm';
import DMYLineGraph from './DMYLineGraph';
// import Typography from '@material-ui/core/Typography';

import * as strings from '../../helpers/strings';

const DMYLineGraphScreen = () => (
  <Page title={strings.lblHistoryRecords} >
    {/* <Typography variant="h5" color={strings.colorPrimary} title={strings.lblHistoricalRecordsChart}>{strings.lblHistoricalRecordsChart}</Typography> */}
        <Grid container spacing={16}>
          <Grid item md={3} xs={12}>
            <DMYGraphFilterForm />
            <DMYGraphFilterFieldForm />
          </Grid>
          <Grid item md={9} xs={12}> 
            <DMYLineGraph />
          </Grid>
        </Grid>
  </Page>
);

export default DMYLineGraphScreen